export enum AppComponentsEnum {
  MAIN = 'ajMain',
  ACTION_BUTTON = 'ajActionButton',
  SEARCH_OFE = 'ajSearchOfe',
  SEARCH_EDU = 'ajSearchEdu',
  SEARCH_PRE = 'ajSearchPre',
  SEARCH_BTN_OFE = 'ajSearchBtnOfe',
  SEARCH_BTN_PRE = 'ajSearchBtnPre',
  CHECKBOX = 'ajCheckbox',
  CENTRES = 'ajCentres',
  CENTRES_AD = 'ajCentresAd',
  CENTRES_SFP = 'ajCentresSfp',
  CENTRES_AD_SE = 'ajCentresAdSe',
  CENTRES_SE_TERRITORI = 'ajCentresSeTerritory',
  CENTRES_VAC_PRE = 'ajCentresVacPre',
  CENTRES_SUPORTS = 'ajCentresSuports',
  FITXA_CENTRE = 'ajFitxaCentre',
  MESSAGE = 'ajMessage',
  OVERLAY = 'ajLoader',
}

export enum AppServicesEnum {
  CONFIGURACIO_SERVICE = 'Configuracio',
  SHARED_PROPERTIES_SERVICE = 'SharedProperties',
  NOTIFICATIONS_SERVICE = 'NotificationsService',
  COMARQUES_SERVICE = 'Comarques',
  TORNS_SERVICE = 'Torns',
  DISTRICTES_SERVICE = 'Districtes',
  MUNICIPIS_SERVICE = 'Municipis',
  NATURALESES_SERVICE = 'Naturaleses',
  NIVELLS_SERVICE = 'Nivells',
  OFERTES_SERVICE = 'Ofertes',
  SERVEIS_SUPORTS = 'ServeisSuports',
  REGIMS_SERVICE = 'Regims',
  SERVEIS_EDUCATIUS_SERVICE = 'ServeisEducatius',
  SERVEIS_TERRITORIALS_SERVICE = 'ServeisTerritorials',
  DATA_SERVICE = 'DataService',
  ENSENYAMENTS_DATA_SERVICE = 'EnsenyamentsData',
  ENSENYAMENTS_PREINSCRIPCIO_CERCA_SERVICE = 'EnsenyamentsPreinscripcioCercaService',
  ENSENYAMENTS_PREINSCRIPCIO_DATA_SERVICE = 'EnsenyamentsPreinscripcioData',
  ENSENYAMENTS_PREINSCRIPCIO_SERVICE = 'EnsenyamentsPreinscripcio',
  CENTRES_PREINSCRIPCIO_SERVICE = 'CentresPreinscripcio',
  CENTRES_SERVICE = 'Centres',
  OPTION_PARSER_SERVICE = 'OptionParser',
}